export default "__VITE_ASSET__DliOFsSk__"